import { IBankAccessResult } from '../../../shared/cardholders-core/models/bank-access-result.interface';
import { HttpService, IResponseLower } from '../../../shared/cardholders-core/services/http-service.service';
import { AppConfigsService } from '../../../config/app-configs.service';
import { Observable } from 'rxjs/observable';
import { Injectable } from '@angular/core';
import { IResponse } from 'core-max-lib';
import { IRegisterUserForBusinessSsoRequest } from "./sso.interfaces";

@Injectable({
    providedIn: 'root'
})
export class SsoService {

    constructor(private httpService: HttpService, private configService: AppConfigsService) { }

    ssoLogin(guid: string): Observable<IResponse<IBankAccessResult>> {
        return this.httpService.post(`${this.configService.appConfigs.apiUrl}/login/businessssologin`, { guid }) as any;
    }

    registerUserFromMaxAccount(req: IRegisterUserForBusinessSsoRequest): Observable<IResponseLower<string>> {
        return this.httpService.postLower<any>(`${this.configService.appConfigs.apiUrl}/registered/businessSso/registerUserFromMaxAccount`, req);
    }

}
